module.exports = __webpack_public_path__ + "static/media/img-example.80c67b69.jpg";